'use client';

import { Button, ButtonGroup, Flex, Text } from '@/_components';
import { type FC, useContext } from 'react';
import type { SentLinkProps } from './SentLink.types';
import { LoginContext } from '@/_contexts/LoginProvider';

export const SentLink: FC<SentLinkProps> = () => {
  const { username, setLoginState } = useContext(LoginContext);

  const onBack = () => setLoginState('login');

  return (
    <form>
      <Flex isColumn={true} gap={8} padding={10}>
        <Text type="small" color="secondary" isBreakAll={true}>
          Sent an email to <b>{username}</b>
        </Text>
        <ButtonGroup>
          <Button
            value="Back"
            type="button"
            onClick={onBack}
            intent="secondary"
          />
        </ButtonGroup>
      </Flex>
    </form>
  );
};
